import { CustomCurrencyPipe } from '../../../../../_helpers/_pipes/custom-currency.pipe';
import { SortPipe } from '../../../../../_helpers/_pipes/sort.pipe';
import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { CoveragesService } from '../../../../../_services/coverages.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbRippleModule, SortPipe, CustomCurrencyPipe],
  selector: 'app-acmic-coverages',
  templateUrl: './acmic-coverages.component.html',
  styleUrls: ['./acmic-coverages.component.scss'],
})
export class AcmicCoveragesComponent implements OnInit {
  @Input() policy: any;
  coverageTerm: any;
  deductibleTerm: any;
  personalInjuryTermAmout: string;
  underInsuredCoverages: any = [];
  unInsuredCoverages: any = [];

  constructor(private coveragesService: CoveragesService) {}

  public checkForSingleVehicle(vehicle): boolean {
    if (vehicle.length === 1) {
      return true;
    }
    return false;
  }
  public toggleCollapse(coverages, index): void {
    const titleElement = document.getElementById('title' + index);
    if (titleElement && !titleElement.classList.contains('active')) {
      titleElement.classList.add('active');
    } else {
      titleElement.classList.remove('active');
    }
    const element = document.getElementById('collapse' + index);
    if (element && !element.classList.contains('show')) {
      element.classList.add('show');
    } else {
      element.classList.remove('show');
    }
  }
  isItHaveLimit(terms: any[], type) {
    if (!terms) {
      return;
    }
    this.coverageTerm = {};
    this.coverageTerm = this.coveragesService.getCoverageLimitTerm(terms, type);
    return this.coverageTerm;
  }
  isItHaveDeductible(terms: any[], type, coverageName) {
    if (!terms) {
      return;
    }
    this.deductibleTerm = this.coveragesService.getCoverageDeductableTerm(
      terms,
      type,
      coverageName
    );
    return this.deductibleTerm;
  }
  isItHavePersonalTermAmout(term, type) {
    if (type === term.termModelType) {
      if (term.termAmount && term.termAmount.includes('$')) {
        this.personalInjuryTermAmout = `${
          term.termAmount.split('$')[1].split(' ')[0]
        }`;
      } else {
        this.personalInjuryTermAmout = term.termAmount;
      }
      return true;
    }
    return false;
  }
  getMotoristCoverageName(coverageName) {
    return coverageName.split('::');
  }
  getSubCoverages(coveragesList) {
    const subCoverages = [];
    coveragesList.forEach((coverage) => {
      subCoverages.push({
        coverageName: coverage.coverageName.split('::')[1],
        coverageLimit: coverage.coverageLimit,
      });
    });
    return subCoverages;
  }
  ngOnInit(): void {
    if (this.policy && this.policy.vehicle) {
      this.policy.vehicle.forEach((vehicle) => {
        const underInsuredCoverages = vehicle.coverages.filter((coverage) =>
          coverage.coverageName.includes('UnderInsured Motorist')
        );
        let formatedUnderInsuredCoverages, formatedUnInsuredCoverages;
        if (underInsuredCoverages) {
          formatedUnderInsuredCoverages = {
            coverageName: 'UnderInsured Motorist',
            subCoverages: this.getSubCoverages(underInsuredCoverages),
          };
        }
        const unInsuredCoverages = vehicle.coverages.filter((coverage) =>
          coverage.coverageName.includes('Uninsured Motorist')
        );
        if (unInsuredCoverages) {
          formatedUnInsuredCoverages = {
            coverageName: 'Uninsured Motorist',
            subCoverages: this.getSubCoverages(unInsuredCoverages),
          };
        }
        vehicle.coverages.forEach((coverage, cIndex) => {
          if (coverage.coverageName.includes('UnderInsured Motorist::')) {
            vehicle.coverages[cIndex] = formatedUnderInsuredCoverages;
          }
          if (coverage.coverageName.includes('Uninsured Motorist::')) {
            vehicle.coverages[cIndex] = formatedUnInsuredCoverages;
          }
        });
        vehicle.coverages = vehicle.coverages.filter(
          (coverage, index) => vehicle.coverages.indexOf(coverage) === index
        );
      });
    }
  }
}
